<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500"> 
  
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Seleccionar estado de oferta
          </v-card-title>
  
          <v-card-text>
            <v-radio-group v-model="estado_oferta">
                <v-radio label="Por defecto (automatizado por el sistema)" value="DEFAULT" /> 
                <p class="mb-0 ml-8 purple--text">Definir manualmente:</p>
                <v-radio label="AUTORIA" value="AUTORIA" /> 
                <v-radio label="LIBRE" value="LIBRE" /> 
                <v-radio :label="getlabel" value="ESTRELLA" /> 
            </v-radio-group> 
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" outlined @click="guardar()">
              <v-icon small left> mdi-check </v-icon>
              Aceptar
            </v-btn>
            <v-btn color="red" outlined @click="cerrar()">
              <v-icon small left> mdi-close </v-icon>
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script> 
    export default {
      data() {
        return {
          dialog: false,  
          estado_oferta: 'DEFAULT',
          resolvePromise: null,
        };
      },
      computed:{
        getlabel(){
            const sid = this.$store.state.CARGO.sede.unidad_negocio;
            if(sid == 1) return 'ESTRELLA'
            return 'ALTO RENDIMIENTO'
        }
      },
      methods: {
        openmodal(item) {  
            this.estado_oferta = item.estado_oferta;
            this.dialog = true;
            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
        cerrar(){
          this.resolvePromise(false);
          this.dialog = false;
        },
        guardar(){
            this.resolvePromise(this.estado_oferta);
            this.dialog = false;
        },
      },
    };
  </script>
  